<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader> <h3 class="card-title">プロフィール</h3></CCardHeader>
          <CCardBody>
            <CForm class="member-info edit-form">
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.cardId.$dirty &&
                      (!$v.itemToEdit.cardId.required ||
                        !$v.itemToEdit.cardId.minLength)
                    "
                  >
                    カードID（16桁）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.cardId.numeric"
                  >
                    数値を入力してください。
                  </div>
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">カードID</label>
                    <div class="col-sm-9">
                      <input
                        type="number"
                        class="form-control"
                        v-model="ConvertId"
                      />
                    </div>
                  </div>
                  <!-- <CInput
                    label="カードID"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.cardId"
                  /> -->
                </CCol>
                <!-- ConvertId -->
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.familyName.$dirty &&
                      !$v.itemToEdit.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.familyName"
                        v-on:input="familyName_furigana"
                      />
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.firstName.$dirty &&
                      !$v.itemToEdit.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.firstName.isKana"
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.firstName"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.givenName.$dirty &&
                      !$v.itemToEdit.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <!-- <CInput
                    label="名"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.givenName"
                  /> -->
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.givenName"
                        v-on:input="givenName_furigana"
                      />
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.lastName.$dirty &&
                      !$v.itemToEdit.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.lastName.isKana"
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.lastName"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CInput
                    description="生年月日"
                    label="生年月日"
                    type="date"
                    horizontal
                    v-model="itemToEdit.birth"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <!-- <div class="radio-checkbok">
                    <input type="checkbox" id="checkbox" v-model="selectUser" />
                    <label for="checkbox">メールがない場合</label>
                  </div> -->

                  <div class="home-checkbok checkbox-s">
                    <input
                      type="checkbox"
                      id="checkbox"
                      v-model="selectUser"
                      @click="switchField()"
                    />
                    <label for="checkbox"> メールがない場合</label>
                  </div>

                  <transition name="fade">
                    <div v-if="!selectUser">
                      <div
                        class="text-danger input-info"
                        v-if="
                          $v.itemToEdit.email.$dirty &&
                          !$v.itemToEdit.email.required
                        "
                      >
                        メールの入力は必須です
                      </div>
                      <CInput
                        label="メール"
                        class="required-mark"
                        horizontal
                        v-model="itemToEdit.email"
                      />
                    </div>

                    <div v-else>
                      <div
                        class="text-danger input-info"
                        v-if="
                          $v.itemToEdit.userName.$dirty &&
                          !$v.itemToEdit.userName.required
                        "
                      >
                        ユーザー名の入力は必須です
                      </div>
                      <CInput
                        label="ユーザー名"
                        class="required-mark"
                        horizontal
                        v-model="itemToEdit.userName"
                      />
                    </div>
                  </transition>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.mobile.$dirty &&
                      !$v.itemToEdit.mobile.required
                    "
                  >
                    電話番号の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.mobile.numeric"
                  >
                    電話番号は数値を入力してください
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.mobile.maxLength"
                  >
                    電話番号は{{
                      limited.mobile.maxLength
                    }}文字以下で入力してください
                  </div>
                  <CInput
                    label="電話番号"
                    type="number"
                    class="required-mark"
                    description="ハイフン(-)は入力しないでください"
                    horizontal
                    v-model="itemToEdit.mobile"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CSelect
                    label="ロール"
                    horizontal
                    :options="userGroupsOptions"
                    :value.sync="userGroupName"
                  />

                  <!-- <p>selected value: {{ userGroupName }}</p> -->
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter>
            <div class="footer-navigation">
              <!-- :disabled="$v.itemToEdit.$invalid" -->
              <CButton
                @click="$v.itemToEdit.$invalid ? requiredFd() : saveProfile()"
                color="success"
                class="ml-0 px-5"
                v-bind:class="$v.itemToEdit.$invalid ? 'inactive' : 'active'"
              >
                <i class="icon cil-user-follow"></i> 登録
              </CButton>
              <!-- <CButton @click="resetdata()"> Reset me </CButton> -->
            </div>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      登録に成功しました。
      <template #header> 登録完了</template>
      <template #footer>
        <CButton
          @click="
            completedModal = false;
            resetData();
          "
          color="danger"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton @click="goEditPage()" color="success"
          ><i class="icon cil-pencil"></i> 続けて編集</CButton
        >
      </template>
    </CModal>
    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorDialog"
    >
      Error: {{ errors }}
      <template #header> Error </template>
      <template #footer>
        <CButton @click="errorDialog = false" color="danger"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import historykana from "historykana";
import * as wanakana from "wanakana";

export default {
  name: "Profile",
  data() {
    return {
       
      confirmModal: false,
      completedModal: false,
      selectUser: false,
      errorDialog: false,
      engFirstName: true,
      engLastName: true,
      allGroups: [],
      userGroupName: "",
      UserGroup: "",
      errors: "",
      userGroupsOptions: [
        { value: "", label: "" },
        { value: "", label: "" },
        { value: "", label: "" },
      ],
      itemToEdit: {
        cardId: "",
        email: "",
        familyName: "",
        givenName: "",
        firstName: "",
        lastName: "",
        birth: "",
        mobile: "",
        userName: "",
      },
      history: [],
      GUserId: "",
    };
  },
  computed: {
    ConvertId: {
      get() {
        return this.itemToEdit.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.itemToEdit.cardId = conv;
      },
    },
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    let Gemail;
    let GuserName;
    if (!this.selectUser) {
      Gemail = { required };
      GuserName = { maxLength: maxLength(100) };
    } else {
      Gemail = { maxLength: maxLength(100) };
      GuserName = { required };
    }
    return {
      itemToEdit: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(100),
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(100),
        },
        cardId: { required, numeric, minLength: minLength(16) },
        mobile: {
          required,
          numeric,
          maxLength: maxLength(20),
        },
        email: Gemail,
        userName: GuserName,
      },
    };
  },

  methods: {
    switchField() {
      this.selectUser
        ? (this.itemToEdit.userName = "")
        : this.$delete(this.itemToEdit, "email");
    },
    saveProfile: function () {
      // this.$v.itemToEdit.$touch();
      if (this.itemToEdit.email) {
        this.GUserId = this.itemToEdit.email;
      } else {
        this.GUserId = this.itemToEdit.userName;
      }
      var urlRequest;
      urlRequest = "/rest/users";
      console.log("editdata" + this.itemToEdit);

      axios
        .post(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.putNewGroup(this.GUserId, this.userGroupName);
          // this.editingModal = false;

          // this.confirmModal = false;
        })
        .catch((err) => {
           

          console.log("Updating profile error: " + err);
          this.errorDialog = true;
          if (err.response.status == 400) {
            this.errors = "このユーザーはすでに存在します";
          } else {
            this.errors = err;
          }
        });
    },

    // put groups
    putNewGroup: function (newName, groupName) {
      var groupRequest = {
        groups: [groupName],
      };

      var urlRequestG = "/rest/users/" + newName + "/groups";

      axios
        .put(urlRequestG, groupRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          // this.goEditPage(); // go to edit page
          this.completedModal = true;
          // Object.assign(this.$data, this.$options.data.call(this));
        })
        .catch((err) => {
           

          console.log(err);
          this.errors = err;
        });
    },
    getAllGroup: function () {
      //Get user infortmation
      var urlRequest = "/rest/groups";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.allGroups = resp.data;
          // this.userSelctionRole();
          this.selectedOption();
          console.log("User Data:" + JSON.stringify(this.allGroups));
        })
        .catch((err) => {
           
          console.log(err);
          this.searchResult = "会員が見つかりませんでした。";
        });
    },
    selectedOption() {
      for (var i = 0; i < this.allGroups.length; i++) {
        if (this.allGroups[i].name == "liberty member") {
          this.userGroupName = this.allGroups[i].id;
        }
      }
      setTimeout(() => this.userSelctionRole(), 1);
    },
    userSelctionRole: function () {
      this.userGroupsOptions = [];
      for (var i = 0; i < this.allGroups.length; i++) {
        let cId = this.allGroups[i].id;
        let cName = this.allGroups[i].name;
        this.userGroupsOptions.push({ value: cId, label: cName });
      }
      return this.userGroupsOptions;
    },
    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    requiredFd() {
      this.$v.itemToEdit.$touch();
    },
    goEditPage() {
      this.$router.push({
        name: "会員情報編集",
        params: { userId: this.GUserId, success: true },
      });
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  },
  beforeMount() {
    this.getAllGroup();
  },
};
</script>
